// Lark BASE Configuration
export const LARK_CONFIG = {
  APP_ID: "cli_a81b09a710b8d02e",
  APP_SECRET: "EZvxJVAlHkH70Zi0n0ZwmbXii3vtm5AM",
  BASE_APP_TOKEN: "D3UYb3HsRalUeBs4AIijlh0opJb",
  TRANSACTIONS_TABLE_ID: "tblnaB9m8kEjHSAV",
  CATEGORIES_TABLE_ID: "tblnaB9m8kEjHSAV",
  API_BASE_URL: "https://open.larksuite.com/open-apis"
};

// Field names mapping from actual Lark BASE data
export const FIELD_NAMES = {
  KEY: "主キー",
  TRANSACTION_DATE: "取引日",
  DEBIT_ACCOUNT: "借方勘定科目",
  DEBIT_PARTNER: "借方取引先名",
  DEBIT_AMOUNT: "借方金額",
  DEBIT_NOTE: "借方備考",
  DEBIT_TAX_TYPE: "借方税区分",
  DEBIT_TAX_AMOUNT: "借方税金額",
  DEBIT_TAX_CLASSIFICATION: "借方内税・外税",
  CREDIT_ACCOUNT: "貸方勘定科目",
  CREDIT_AMOUNT: "貸方金額",
  CREDIT_TAX_AMOUNT: "貸方税金額",
  CREDIT_TAX_CLASSIFICATION: "貸方内税・外税",
  CREDIT_ITEM: "貸方品目",
  CREATED_AT: "作成日時"
};

// Fiscal year configuration (May start, April end)
export const FISCAL_YEAR_CONFIG = {
  START_MONTH: 5, // May
  END_MONTH: 4    // April
};
